<template>
  <div class="img_box" v-loading="loading" element-loading-text="等待接口数据返回中······">
    <div :style="sizes" v-for="(item,index) in imgList" :key="index" class="img_list">
      <img
        class="el-upload-list__item-thumbnail"
        :src="item" alt=""
      >
      <span class="el-upload-list__item-actions">
        <span
          class="el-upload-list__item-preview"
          @click="handlePictureCardPreview(item)"
        >
          <i class="el-icon-zoom-in"></i>
        </span>
        <span
          class="el-upload-list__item-delete"
          @click="handleRemove(index)"
        >
          <i class="el-icon-delete"></i>
        </span>
      </span>
    </div>
    <el-upload
      action="#"
      :style="sizes"
      list-type="picture-card"
      :http-request="uploadImg"
      :show-file-list="false"
      :multiple="multiple"
      :before-upload="beforeAvatarUpload"
      accept="image/*"
      class="img_box_upload"
    >
      <i class="el-icon-plus"></i>
    </el-upload>
    <el-dialog append-to-body :visible.sync="dialogVisibleImg" class="dialog_come">
      <img width="100%" :src="dialogImageUrl" alt="">
    </el-dialog>
  </div>
</template>

<script>
// import api from "@/api";
// import {ossUpload} from "@/libs/upload";

export default {
  props: {
    //多图还是单图
    mode: {
      type: String,
    },
    //是否需要支持多选
    multiple: {
      type: Boolean,
    },
    //父组件传过来的图片数据
    list: {
      type: Array | Object
    },
    sizes: {
      type: Array | Object
    }
  },
  name: "unloadImg",
  data() {
    return {
      //图片预览的数据
      dialogImageUrl: '',
      dialogVisibleImg: false,
      //图片列表
      imgList: [],
      aliOssInfo: {},
      loading: false
    }
  },
  watch: {
    list(odata) {
      if (odata.length) {
        this.imgList = this.list
      } else {
        this.imgList = []
      }
    }
  },
  mounted() {
    this.getInfoList()
  },
  methods: {
    //图片回显
    getInfoList() {
      if (this.list && this.list.length) {
        this.imgList = this.list
      } else {
        this.imgList = []
      }
    },
    //删除当前的图片
    handleRemove(file) {
      this.imgList.splice(file, 1)
      this.getList()
    },
    //查看大图
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file;
      this.dialogVisibleImg = true;
    },
    //上传文件之前进行数据验证
    beforeAvatarUpload(file) {
      const isJPG = file.type.substr(0, 5) === 'image';
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isJPG) {
        this.$message.error('当前上传的内容不是图片文件内容!');
        return isJPG
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!');
        return isLt2M;
      }
    },
    getCaption(obj,state) {
      var index=obj.lastIndexOf("\.");
      if(state==0){
        obj=obj.substring(0,index);
      }else {
        obj=obj.substring(index+1,obj.length);
      }
      return obj;
    },
    async uploadImg(file) {

    },
    // 图片上传操作
    async uploadS3Img(file) {
      this.loading = true
      const resData = await api.AWS_S3()
      this.aliOssInfo = resData
      var albumBucketName = this.aliOssInfo.bucketName
      var bucketRegion = this.aliOssInfo.bucketRegion
      var targetRegion = this.aliOssInfo.targetBucketRegion
      var IdentityPoolId = this.aliOssInfo.identityPoolId
      AWS.config.update({
        region: bucketRegion,
        credentials: new AWS.CognitoIdentityCredentials({
          IdentityPoolId: IdentityPoolId
        })
      })
      var s3 = new AWS.S3({
        apiVersion: '2006-03-01',
        region: targetRegion,
        params: {Bucket: albumBucketName}
      })
      var files = file.file
      var fileName = this.getTimes() + '.' + this.getCaption(files.name,1);
      var albumPhotosKey = 'micros/'
      var photoKey = albumPhotosKey + fileName
      s3.upload({
        Bucket: albumBucketName,
        Key: photoKey,
        Body: files
      }, (error, data) => {
        if (error) {
          this.$message.error('服务器异常，重新试一下')
        } else {
          let imgurl = `${this.aliOssInfo.domain}/${data.key}`;
          if (this.mode == "one") {
            this.imgList = [];
            this.imgList.push(imgurl);
            this.loading =false
            this.getList()
          } else {
            this.imgList.push(imgurl);
            this.loading =false
            this.getList()
          }
        }
      })
    },
    //将修改后的数据同步传递到父组件
    getList() {
      this.$emit('send', this.imgList)
    },
    getTimes() {
      let data = new Date()
      let year = data.getFullYear().toString()
      let month = data.getMonth() + 1
      return year + month + data.getDate() + data.getHours() + data.getMinutes() + data.getSeconds() + data.getMilliseconds()
    },
  }
}
</script>

<style scoped lang="scss">
@import "src/assets/style/commont";
</style>

<style lang="scss">
@import "src/assets/style/pubilcCommont";
</style>

